import type {AboutUs} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useCompany() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'aboutUsGlobal',
      depth: 3,
      draft: !!route.query.preview,
    })

    return result as Populated<AboutUs>
  }

  return {fetch}
}
